class HoverTextHandler extends HTMLElement {
    constructor() {
      super();
      
      // Find elements within the nearest parent multicolumn section
      const section = this.closest('.multicolumn');
      this.hoverImages = section.querySelectorAll('[data-hover-item]');
      this.hoverTitle = section.querySelector('[data-hover-title]');
      this.hoverText = section.querySelector('[data-hover-text]');
  
      // Setup hover handlers
      this.hoverImages.forEach((item) => {
        const title = item.dataset.title;
        const text = item.dataset.text;
  
        item.addEventListener('mouseover', () => {
          this.hoverTitle.innerText = title;
          this.hoverText.innerHTML = text;
          
          // Update active states
          this.hoverImages.forEach(img => img.classList.remove('active'));
          item.classList.add('active');
        });
      });
    }
  }
  
  customElements.define('hover-text-handler', HoverTextHandler);